const TitlesHeading = {
  SpaceCertificatesList: "Space Certificates List",
  listPurchaseOrder: "Record PO List",
  createJob: "Job Creation",
  listIndent: "Indent List",
  listJob: "Job List",
  sapGrnName: "SAP GRN Bulk Upload",
  jobDashboard: "Dashboard",
  indentDashboard: "Dashboard",
  indentTransporterDashboard: "Indent Transporter Dashboard",
  indentVehicleDashboard: "Indent Vehicle Dashboard",
  listUserMaster: "User Master List",
  listCustomerMaster: "Customer Master List",
  listWarehouseMaster: "warehouse Master List",
  listEquipmentMaster: "Equipment Master List",
  listConsignmentMaster: "Consignment Master List",
  listCurrencyMaster: "Currency Master List",
  listEmployeeMaster: "Employee Master List",
  listEmployerMaster: "Employer Master List",
  listSupplierMaster: "Supplier Master List",
  listTransporterMaster: "Transporter Master List",
  listPVCategoryMaster: "PV Category Master List",
  listToolsMaster: "Tools Master List",
  receiptTypeMaster: "Receipt Type Master List",
  listSpareMaster: "Spare Master List",
  listSacCodeMaster: "SAC Code Master List",
  listParameterMaster: "Parameter Master List",
  listPOMaster: "PO Master List",
  listWOMaster: "WO Master List",
  listBinMaster: "Bin Master List",
  listCommodityMaster: "Commodity Master List",
  listRepresentativeMaster: "Transporter Representative Master List",
  listContactMaster: "Contact Master List",
  listVendorServiceMaster: "Service Master List",
  listEquipmentChecklistMaster: "Equipment Checklist Master List",
  listDepartmentMaster: "Department Master",
  listConsigneeMaster: "Consignee Master",
  listMaterialGroupMaster: "Material Group Master",
  listCustomStationMaster: "Custom Station Master",
  listConsignerMaster: "Consigner Master",
  listSafetyObservation: "Safety Observation List",
  listToolsTackles: "Tools Tackles List",
  listStockVerification: "Stock Verification List",
  listAuditReport: "Audit Report",
  listEquipment: "Equipment Compliance List",
  damageCliam: "Damage Claim List",
  listInvoice: "Invoice List",
  listSafetyEmployee: "Safety Employee List",
  listSpareStockmgmt: "Spare Stock Management List",
  contractMasterUploadData: "Upload Data based on BOE No. to Warehouse",
  SapPendingReasons: "SAP Pending Reasons List",
  vehicleTypeMaster: "Vehicle Type Master List",
  listUOMMaster: "UOM Master",
  listPackageMaster: "Package Type Master List",
};

const PathsHeading = {
  listPurchaseOrder: "Record PO",
  createPO: "Record PO",
  createIndent: "Create Indent",
  updatepo: "Update Record PO",
  createJob: "Create Job",
  updatejob: "Update Job",
  viewJob: "View Job",
  jobVehicle: "Job Vehicle",
  primaryGRN: "Create Primary GRN",
  updateDiversion: "Update Diversion",
  createDiversion: "Create Diversion",
  updatePrimaryGRN: "Update Primary GRN",
  createUnload: "Create Unload Advice",
  updatejob: "Update Job",
  jobVehicle: "Job Vehicle",
  listSafetyObservation: "Safety Observation",
  listToolsTackles: "Tools Tackles",
  indentVehicle: "Indent Loading Advice",
  updateunload: "Update Unload Advice",
  createSecodaryGRN: "Create Secodary GRN",
  updateSecondaryGRN: "Update Secondary GRN",
  createIndentTransporter: "Transportation Details",
  updateIndentTransporter: "Update Transportation Details",
  goodsJob: "Goods Issue",
  delivery: "Delivery",
  EditGoodsJob: "Edit Goods Issue",
  damageCliam: "Damage Claim",
  userMaster: "User Master",
  listUserMaster: "Create User Authorization",
  editUser: "Update User Master",
  customerMaster: "Customer Master",
  listCustomerMaster: "Create Customer Master",
  editCustomer: "Update Customer Master",
  editDepartment: "Update Department Master",
  editCha: "View CHAIL Master",
  warehouseMaster: "Create Warehouse Master",
  listWarehouseMaster: "Create Warehouse Master",
  editWarehouse: "Update Warehouse Master",
  equipmentMaster: "Equipment Master",
  editEquipment: "Update Equipment Master",
  consignmentMaster: "Consignment Master",
  editConsignment: "Update Consignment Master",
  currencyMaster: "Currency Master",
  editCurrency: "Update Currency Master",
  employeeMaster: "Employee Master",
  editEmployee: "Employee Master",
  employerMaster: "Employer Master",
  editEmployer: "Employer Master",
  supplierMaster: "Supplier Master",
  editSupplier: "Supplier Master",
  transporterMaster: "Transporter Master",
  editTransporter: "Transporter Master",
  pvcategoryMaster: "PV Category master",
  editPVCategoryMaster: "PV Category master",
  toolsMaster: "Tools Master",
  editToolsMaster: "Tools Master",
  spareMaster: "Spare Master",
  editSpareMaster: "Spare Master",
  sacCodeMaster: "SAC Code Master",
  listParameterMaster: "Parameter Master",
  editSacCodeMaster: "SAC Code Master",
  poMaster: "PO Master",
  editPoMaster: "PO Master",
  woMaster: "WO Master",
  editWoMaster: "WO Master",
  binMaster: "Create Bin Master",
  editBinMaster: "Bin Master",
  commodityMaster: "Commodity Master",
  editCommodityMaster: "Commodity Master",
  representativeMaster: "Transporter Representative Master",
  editRepresentativeMaster: "Transporter Representative Master",
  contactMaster: "Contact Master",
  editContactMaster: "Contact Master",
  vendorServiceMaster: "Vendor Service Master",
  editVendorServiceMaster: "Vendor Service Master",
  equipmentChecklistMaster: "Equipment Checklist Master",
  editEquipmentChecklistMaster: "Equipment Checklist Master",
  listEquipmentMaster: "Create Equipment Master",
  listConsignmentMaster: "Consignment Master",
  listCurrencyMaster: "Currency Master",
  listEmployeeMaster: "Employee Master",
  listEmployerMaster: "Employer Master",
  listSupplierMaster: "Supplier Master",
  listTransporterMaster: "Transporter Master",
  listPVCategoryMaster: "PV Category Master",
  listToolsMaster: "Tools Master",
  listSpareMaster: "Spare Master",
  listSacCodeMaster: "SAC Code Master",
  listPOMaster: "PO Master",
  listWOMaster: "WO Master",
  listBinMaster: "Create Bin Master",
  listCommodityMaster: "Commodity Master",
  listRepresentativeMaster: "Transporter Representative Master",
  listContactMaster: "Contact Master",
  listVendorServiceMaster: "Service Master",
  listEquipmentChecklistMaster: "Equipment Checklist Master",
  safetyObservation: "Create Safety Observation",
  updatesafetyObservation: "Update Safety Observation",
  safetyToolsAndTackels: "Create Safety-Tools & Tackles",
  updatesafetyToolsAndTackels: "Update Safety-Tools & Tackles",
  safetyEmployee: "Create Safety Employee",
  updateSafetyEmployee: "Update Safety Employee",
  equipmentComplaince: "Equipment Compliance",
  equipmentMaintenance: "Create Equipment Maintenance",
  spareStockManagement: "Create Spare Stock Management",
  equipPreventiveMaintenance: "Create Equip-Preventive Maintenance",
  equipFuelConsumption: "Create Equip-Fuel Consumption",
  viewPrimaryGRN: "View Primary GRN",
  viewunload: "View Unload Advice ",
  viewJobDiversion: "View Job Diversion",
  viewIndent: "View Indent",
  viewIndentDelivery: "View Indent Delivery",
  viewIndentGoods: "View Indent Goods Issue",
  viewIndentLoadingAdvice: "View Indent Loading Advice",
  viewIndentTransporter: "View indent Transporter",
  indentVehicleReporting: "Create Vehicle Reporting",
  indentVehicleTracking: "Vehicle Tracking",
  viewIndentVehicleReporting: "View Vehicle Reporting",
  editIndentVehicleReporting: "Update Vehicle Reporting",
  indentVehicleDelivery: "Indent Delivery",
  indentGoodsIssue: "Indent Goods Issue",
  indentVehicleTrackingList: "Indent Vehicle Tracking",
  listDepartmentMaster: "Department Master",
  ListChaMaster: "Upload Excel from CHAIL",
  listConsigneeMaster: "Consingee Master",
  listConsignerMaster: "Consinger Master",
  listMaterialGroupMaster: "Material Group Master",
  listCustomStationMaster: "Custom Station Master",
  listStockVerification: "Stock Verification",
  listInvoice: "Invoice",
  listSpareStockmgmt: "Spare Stock Management",
  listEquipment: "Equipment Compliance",
  stockVerification: "Stock Verification",
  stockRegularization: "Stock Regularization",
  auditReport: "Audit Report",
  editDamageCliam: "Edit Damage Claim",
  createInvoice: "Create Invoice",
  safetyEmployee: "Safety Employee",
  updateInvoice: "View Invoice",
  editSpareStockManagement: "Update Spare Stock Management",
  contractMasterUploadData: "Upload Contract Master",
  SapPendingReasons: "SAP Pending Reasons",
  listUOMMaster:"UOM Master",
  editUom: "Update UOM Master",
  listPackageMaster: "Package Master",
};

const TitlesNavigation = {
  SpaceCertificatesList: "Space Certificates List",
  JobName: "JOB",
  poName: "Record PO",
  sapGrnName: "SAP GRN Bulk Upload",
  userName: "User Master",
  customerName: "Customer Master",
  warehouseName: "Warehouse Master",
  EquipmentName: "Equipment Master",
  Employername: "Employer Master",
  EmployeeName: "Employee Master",
  consignmentName: "Consignment Master",
  SupplierName: "Supplier Master",
  TransporterName: "Transporter Master",
  PVCatergory: "PV Category Master",
  toolsName: "Tools Master",
  receiptTypeName: "Receipt Type Master",
  SpareName: "Spare Master",
  binName: "Bin Master",
  parameterName: "Parameter  Master",
  commodityName: "Commodity Master",
  representativeName: "Transporter Representative Master",
  serviceName: "Service Master",
  departmentName: "Department Master",
  chaName: "CHAIL Master",
  consigneeName: "Consignee Master",
  listIndent: "Indent",
  damageCliamName: "Damage Claim",
  invoiceName: "Invoice",
  stockVerificationName: "Stock Verification",
  stockRegularization: "GRN or GI Not Done",
  auditReportName: "Audit Report",
  materialGroupMaster: "Material Group Master",
  customStationMaster: "Custom Station Master",
  safetyObservationName: "Safety Observation",
  toolstacklesName: "Tools and tackles",
  spareStockMgmt: "Spare Stock Management",
  safetyEmployeeName: "Safety Employee",
  listPurchaseOrder: "Warehouse / Record PO",
  createPO: "Record PO/ Record PO",
  addPOLineItems: "Record PO/ Record PO / Add Line Items",
  updatepo: "Record PO/ Update Record PO",
  createJob: "Warehouse/Job Creation/Create Job",
  listJobCreation: "Warehouse/Job",
  updatejob: "Job / Update Job",
  viewJob: "Job / View Job",
  jobVehicle: "Job/Job-Vehicle",
  primaryGRN: "Job/Job-Vehicle/Create Primary GRN",
  updateDiversion: "Job/Update Diversion",
  createDiversion: "Job/Create Diversion",
  updatePrimaryGRN: "Job/Update Primary GRN",
  listIndent: " Indent",
  createUnload: "Warehouse/Unload Creation/Create Unload Advice",
  updateunload: "Unload / Update Unload ",
  createSecodaryGRN: "Job/Create Secodary GRN",
  updateSecondaryGRN: "Job/Update Secodary GRN",
  createIndentTransporter:
    "Warehouse / Indent /Create Indent / Transporter Details",
  updateIndentTransporter:
    "Warehouse / Indent /Create Indent / Update Transporter Details",
  goodsJob: "Warehouse / Indent / Goods Issue",
  delivery: "Warehouse / Indent / Delivery",
  editIndent: "Indent/Update Indent",
  createLoadingAdvice: "Indent/Loading Advice",
  updateLoadingAdvice: "Indent/Update Loading Advice",
  goodsJob: "Warehouse / Indent / Goods Issue",
  indentVehicle: "Indent/Indent Loading Advice",
  delivery: "Warehouse / Indent / Delivery",
  EditGoodsJob: "Warehouse / Indent / Edit Goods Issue",
  jobDashboard: "Warehouse / Job / Dashboard",
  damageCliam: "Warehouse / Damage Claim",
  indentDashboard: "Warehouse / Indent / Dashboard",
  indentTransporterDashboard: "Warehouse / Indent Transporter Dashboard",
  indentVehicleDashboard: "Warehouse / Indent Vehicle Dashboard",
  userMaster: "Warehouse / User Master",
  listUserMaster: "Warehouse / User Master List",
  editUser: "User Master / Update User Master",
  customerMaster: "Warehouse / CustomerMaster",
  listCustomerMaster: "Warehouse / Customer Master List",
  editCustomer: "Customer Master / Update Customer Master",
  editDepartment: "Department Master / Update Department Master",
  editCha: "CHAIL Master / View CHAIL Master",
  warehouseMaster: "Warehouse / WarehouseMaster",
  listWarehouseMaster: "Warehouse / WarehouseMaster",
  editWarehouse: "Warehouse Master / Update Warehouse Master",
  equipmentMaster: "Warehouse / Equipment Master",
  editEquipment: "Equipment Master / Update Warehouse Master",
  consignmentMaster: "Warehouse / Consignment Master",
  editConsignment: "Consignment Master / Update Consignment Master",
  currencyMaster: "Warehouse / Currency Master",
  editCurrency: "Currency Master / Update Currency Master",
  employeeMaster: "Warehouse / Employee Master",
  editEmployee: "Employee Master / Update Employee Master",
  employerMaster: "Warehouse / Employer Master",
  editEmployer: "Employer Master / Update Employer Master",
  supplierMaster: "Warehouse / Supplier Master",
  editSupplier: "Supplier Master / Update Supplier Master",
  transporterMaster: "Warehouse / Transporter Master",
  editTransporter: "Transporter Master / Update Transporter Master",
  pvcategoryMaster: "Warehouse / PV Category Master",
  editPVCategoryMaster: "PV Category Master / Update PV Category Master",
  toolsMaster: "Warehouse / Tools Master",
  editToolsMaster: "Tools Master / Update Tools Master",
  editSpareMaster: "Spare Master / Update Spare Master",
  spareMaster: "Warehouse / Spare Master",
  sacCodeMaster: "Warehouse / SAC Code Master",
  editSacCodeMaster: "SAC Code Master / Update SAC Code Master",
  poMaster: "Warehouse / PO Master",
  editPoMaster: "PO Master / Update PO Master",
  woMaster: "Warehouse / WO Master",
  editWoMaster: "WO Master / Update WO Master",
  binMaster: "Warehouse / Create Bin Master",
  editBinMaster: "Bin Master / Update Bin Master",
  commodityMaster: "Warehouse / Commodity Master",
  editCommodityMaster: "Commodity Master / Update Commodity Master",
  representativeMaster: "Warehouse / Transporter Representative Master",
  editRepresentativeMaster:
    "Transporter Representative Master / Update Transporter Representative Master",
  contactMaster: "Warehouse / Contact Master",
  editContactMaster: "Contact Master / Update Contact Master",
  vendorServiceMaster: "Warehouse / Vendor Service Master",
  editVendorServiceMaster:
    "Vendor Service Master / Update Vendor Service Master",
  equipmentChecklistMaster: "Warehouse / Equipment Checklist Master",
  editEquipmentChecklistMaster:
    "Equipment Checklist Master / Update Equipment Checklist Master",
  listEquipmentMaster: "Warehouse / Equipment Master List",
  listConsignmentMaster: "Warehouse / Consignment Master List",
  listCurrencyMaster: "Warehouse / Currency Master List",
  listEmployeeMaster: "Warehouse / Employee Master List",
  listEmployerMaster: "Warehouse / Employer Master List",
  listSupplierMaster: "Warehouse / Supplier Master List",
  listTransporterMaster: "Warehouse / Transporter Master List",
  listPVCategoryMaster: "Warehouse / PV Category master List",
  listToolsMaster: "Warehouse / Tools Master List",
  listSpareMaster: "Warehouse / Spare Master List",
  listSacCodeMaster: "Warehouse / SAC Code Master List",
  listParameterMaster: "Warehouse / Parameter Master List",
  listPOMaster: "Warehouse / PO Master List",
  listWOMaster: "Warehouse / WO Master List",
  listBinMaster: "Warehouse / Bin Master List",
  listCommodityMaster: "Warehouse / Commodity Master List",
  listRepresentativeMaster:
    "Warehouse / Transporter Representative Master List",
  listContactMaster: "Warehouse / Contact Master List",
  listVendorServiceMaster: "Warehouse / Service Master list",
  listEquipmentChecklistMaster: "Warehouse / Equipment Checklist Master List",
  safetyObservation: "Warehouse / Safety Observation",
  safetyToolsAndTackels: "Warehouse / Safety-Tools & Tackles",
  safetyEmployee: "Warehouse / Safety Employee",
  equipmentComplaince: "Warehouse / Equipment Compliance",
  equipmentMaintenance: "Warehouse / Equipment Maintenance",
  spareStockManagement: "Warehouse / Spare Stock Management",
  equipPreventiveMaintenance: "Warehouse / Equip-Preventive Maintenance",
  equipFuelConsumption: "Warehouse / Equip-Fuel Consumption",
  viewPrimaryGRN: "Job/View Primary GRN",
  viewunload: "Unload / View Unload ",
  viewJobDiversion: "Diversion/ View Job Diversion",
  viewIndent: "Indent/ View Indent",
  viewIndentDelivery: "Indent/ Delivery",
  viewIndentGoods: "Indent / Goods Issue",
  viewIndentLoadingAdvice: "Indent / Loading Advice",
  viewIndentTransporter: "Indent / Transporter Details",
  indentVehicleReporting: "Indent / Vehicle Reporting",
  indentVehicleTracking: "Indent / Vehicle Tracking",
  editIndentVehicleReporting: "Indent / Vehicle Reporting",
  indentVehicleDelivery: "Indent / Indent Delivery",
  indentGoodsIssue: "Indent / Indent Goods Issue",
  indentVehicleTrackingList: "Indent / Indent Vehicle Tracking",
  listDepartmentMaster: "Warehouse / Department Master",
  ListChaMaster: "Warehouse / CHAIL Master",
  listConsigneeMaster: "Warehouse / Consignee Master",
  listConsignerMaster: "Warehouse / Consigner Master",
  listMaterialGroupMaster: "Material Group Master",
  listCustomStationMaster: "Custom Station Master",
  listSafetyObservation: "Safety Observation",
  listToolsTackles: "Tools Tackles",
  listStockVerification: "Stock Verification",
  listInvoice: "Invoice",
  listSpareStockmgmt: "Spare Stock Management",
  listEquipment: "Equipment Compliance",
  stockVerification: "Stock Verification",
  editDamageCliam: "Warehouse / Update Damage Claim",
  createInvoice: "Warehouse / Invoice",
  contractMasterUploadData: "Upload Data based on BOE No. to Warehouse",
  SapPendingReasons: "SAP Pending Reasons",
  uomName:"Warehouse / UOM Master",
  listPackageMaster: "Warehouse / Package Type Master List",
};

const PathsNavigation = {
  listPurchaseOrder: "createpo",
  createJob: "createjob",
  createIndent: "createindent",
  listUserMaster: "createauthorizationuser",
  listCustomerMaster: "customermaster",
  listWarehouseMaster: "warehousemaster",
  listEquipmentMaster: "equipmentmaster",
  listEmployeeMaster: "employeemaster",
  listEmployerMaster: "employermaster",
  listSupplierMaster: "suppliermaster",
  listTransporterMaster: "transportermaster",
  listToolsMaster: 'toolsmaster',
  receiptTypeMaster: 'receipttypemaster',
  listPOMaster: "pomaster",
  listWOMaster: "womaster",
  listBinMaster: "binmaster",
  listEquipmentChecklistMaster: "equipmentchecklistmaster",
  listDepartmentMaster: "departmentmaster",
  ListChaMaster: "uploadexcelwithchail",
  listSafetyObservation: "createsafetyobservation",
  listToolsTackles: "createsafetytoolsandtackles",
  listSafetyEmployee: "create-safety-employee",
  listStockVerification: "createstockverification",
  listAuditReport: "createauditreport",
  listEquipment: "equipmentcomplaince",
  listInvoice: "createinvoice",
  listSpareStockmgmt: "sparestockmanagement",
  contractMasterUploadData: "Upload Data based on BOE No. to Warehouse",
  vehicleTypeMaster: 'vehicletypemaster',
  listUOMMaster:"uommaster",
  listPackageMaster:""
};

export default {
  TitlesHeading,
  TitlesNavigation,
  PathsHeading,
  PathsNavigation,
};
